// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__fGI92","col":"Table_col__3dGqO","fulfillmentStatus":"Table_fulfillmentStatus__2Mvvx","emailCol":"Table_emailCol__1CMoI"};